import React, {useMemo} from 'react';
import {useIntl} from 'react-intl';
import {Container} from 'react-bootstrap';
import {Link} from 'react-router-dom';
import {PageTitle} from '../../../_metronic/layout/core';
import {useGetCustomers} from '../../Auth/Hooks/CustomerManager';
import {CustomerSystem} from '../../Auth/Types/customer';
import ApsRequestForm from '../Components/ApsRequestForm';

const ApsRequestPage = (): JSX.Element => {
  const intl = useIntl();
  const {data: customers = []} = useGetCustomers();
  const buOptions = useMemo(
    () => customers.filter((customer) => customer.system === CustomerSystem.CIS),
    [customers]
  );

  return (
    <Container fluid className="px-0">
      <PageTitle
        breadcrumbs={[{title: 'DivOps', path: '/divops', isSeparator: false, isActive: false}]}
      >
        {intl.formatMessage({id: 'DIVOPS.APS.PAGE.TITLE'})}
      </PageTitle>

      <div className="card mx-5">
        <div className="card-body py-10">
          <div className="d-flex justify-content-end mb-6">
            <Link to="/divops/aps/historique" className="btn btn-light-primary">
              <i className="fas fa-history me-2"></i>
              {intl.formatMessage({id: 'DIVOPS.APS.HISTORY.LINK'})}
            </Link>
          </div>

          {/* key : réinitialise le formulaire (BU unique pré-sélectionnée) une fois les BU chargées */}
          <ApsRequestForm
            key={buOptions.map((bu) => bu.id).join('-')}
            buOptions={buOptions}
            withAddress
            onSuccess={() => undefined}
            onCancel={() => undefined}
          />
        </div>
      </div>
    </Container>
  );
};

export default ApsRequestPage;
